<template>
  <div>
    <table class="table table-fixed table-bordered">
      <tbody>
      <SiviAttributeComponent v-for="(attribute, key) in entity.attributes"
                              :attribute="attribute"
                              :entity="entity" :key="key"/>
      </tbody>
    </table>
    <a-collapse v-if="entity.entities" style="margin-top: 1.5rem;">
      <a-collapse-panel v-for="(subEntity, key) in entity.entities"
                        :key="key"
                        :header="subEntity.description">
        <SiviEntityComponent :entity="subEntity"/>
      </a-collapse-panel>
    </a-collapse>

    <div v-if="!hasSubEntities && !hasDataAttribute" style="font-size: 15px">
      <br><b>De maatschappij heeft de inhoud van de bijlage niet meegeleverd.</b></div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import store from '../store';
import SiviAttributeComponent from "~/modules/sivi/components/SiviAttributeComponent";
import { SIVIEntityLabelEnum } from "~/enums";
// import store from '../store';

export default {
  name: "SiviEntityComponent",
  props: {
    entity: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      siviMessage: null,
    }
  },
  computed: {
    ...mapGetters({
      staticSearches: "$_templating/staticSearches",
    }),
    staticSearches() {
      return store.state.staticSearches;
    },
    hasDataAttribute() {
      return this.entity.attributes.filter(attribute => {
        return attribute.label === SIVIEntityLabelEnum.FILE_DATA;
      }).length > 0;
    },
    hasSubEntities() {
      return this.entity.entities.length > 0;
    }
  },
  created() {
    const STORE_KEY = '$_search';
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  },
  mounted() {
    // siviApi.getByAfdMessageId(this.afdMessageId).then((data) => {
    //     this.siviMessage = data.data;
    // })
  },
  components: {
    SiviAttributeComponent
  },
}
</script>

<style scoped>
.csv-export-component {
}

table.table th, table.table td {
  padding: 1.5rem 1rem;
}
</style>
